// extracted by mini-css-extract-plugin
module.exports = {"stars":"StarRating-module__stars___bpMfb"};